import { NgModule } from '@angular/core';
import { NgIf } from '@angular/common';
import { InsuranceCarComponent } from './insurance-car.component';
import {
    WucBalloonModule,
    WucDisplayFieldModule,
    WucDropTriggerModule,
    WucIconUiModule,
    WucLinkModule,
    WucRackModule,
} from '@inshared/website-ui-components';
import { DateFormatPipeModule, KentekenModule } from '@inshared/shared/util-pipes';

@NgModule({
    imports: [
        DateFormatPipeModule,
        KentekenModule,
        NgIf,
        WucBalloonModule,
        WucDisplayFieldModule,
        WucDropTriggerModule,
        WucIconUiModule,
        WucLinkModule,
        WucRackModule,
    ],
    declarations: [
        InsuranceCarComponent,
    ],
    exports: [
        InsuranceCarComponent,
    ],
})
export class InsuranceCarModule { }
